import React from 'react';
import ClassDropdown from "./classdropdown";
import GradePicker from './gradepicker';
import StudentField from './studentfield';
import Quiz from './senderQuiz';

class QuizSender extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
            quizId: 22,
            blurb: '',
            quizName: '',
            course: 0,
            grade: 0,
            school: 0,
            courses: [],
            students: [],
            quizes: [],
            schools: [],
            questions: [],
            selectedStudents:[],
        };
    }

    componentDidMount = () => {        
        fetch("https://api.involvedk12.org/api/getQuizIds.php").then(res => res.json()).then((result) => {
            this.setState({
                quizes: result,
            })
        }).then(
            fetch('https://api.involvedk12.org/api/getSchools.php').then(res => res.json()).then((result) => {
                this.setState({
                   schools: result,    
                })
            })
        );
    }
    
    setStudents = (passedValue) => {
        fetch('https://api.involvedk12.org/api/getStudents.php?class=' + passedValue)
            .then(res => res.json())
            .then(result => {
                const passedResult = [];
                result.forEach(student => {
                    passedResult.push(student.id);
                });
                this.setState({
                    selectedStudents: passedResult,
                })
            })
    }

    getCourses = (school,grade) => {
        fetch('https://api.involvedk12.org/api/getClasses.php?school=' + school + '&grade=' + grade)
            .then(res => res.json())
            .then(result => {
                this.setState({
                    courses: result,
                })
                console.log(result)
            });
    }

    setGrade = e => {
        const inGrade = parseInt(e.target.value);
        this.setState({
            grade: inGrade,
        });

        this.setStudentArray(this.state.school,inGrade);
        this.getCourses(this.state.school,inGrade);
    }

    setSchool = e => {
        const inSchool = parseInt(e.target.value);
        this.setState({
            school: inSchool,
        });
        this.setStudentArray(inSchool,this.state.grade);
        this.getCourses(inSchool,this.state.grade);
    }
    setStudentArray = (schoolIn,gradeIn) => {
        fetch('https://api.involvedk12.org/api/getStudents.php?school=' + schoolIn + "&grade=" + gradeIn)
            .then(res => res.json())
            .then(result => {
                this.setState({
                    students: result,
                })
                console.log(result);
            });
    }


    setCourse = e => {
        const inCourse = parseInt(e.target.value);
        this.setState({
            course: inCourse,
        });
        this.setStudents(inCourse);
    }


    updateQuiz = e =>{
        const newQuizId = parseInt(e.target.value);
        if(newQuizId === 0)
        {    
            this.setState({
                quizId: newQuizId,
                questions: [],
            },
            this.repopulateQuiz(newQuizId))
        }else{
            this.setState({
                quizId: newQuizId,
            },
            this.repopulateQuiz(newQuizId))
        }
    }
    

    repopulateQuiz = (quizId) => {
        fetch("https://api.involvedk12.org/api/getQuizes.php?quizId=" + quizId).then(res => res.json()).then((result) => {
            this.setState({
                questions: result.questions,
                blurb: result.blurb,
                quizName: result.quizName,
            });
        }).then(console.log(this.state.questions));
    }



    checkAll = () => {
        const array = [];
        this.state.students.forEach(student => {
            array.push(student.id);
        });
        this.setState({
            selectedStudents: array,
        })
    }
    uncheckAll = () =>{
        this.setState({
            selectedStudents: [],
        })
    }

    
    sendQuiz = () => {
        //let val = document.getElementById("activeNow").checked;
        // let hold = "";
        // if(val)
        // {
        //     hold = "&priority=1";
        // }
        // alert(JSON.stringify(this.state.selectedStudents) + " | " + this.state.quizId);
        fetch("https://api.involvedk12.org/api/sendQuiz.php?quiz=" + this.state.quizId + "&users=" + this.state.selectedStudents).then(alert("Sent Quiz"));
    }

    updateStudents = e => {
        const student = parseInt(e.target.id);
        const array = [...this.state.selectedStudents];
        if (e.target.checked) {
            array.push(student);
            this.setState({
                selectedStudents: array,
            })
        } else {
            const array = [...this.state.selectedStudents];
            let deleteIndex = -1;
            for (let index = 0; index < this.state.selectedStudents.length; index++) {
                if (this.state.selectedStudents[index] === student) {
                    deleteIndex = index;
                    break;
                }
            }
            array.splice(deleteIndex, 1);

            this.setState({
                selectedStudents: array,
            });
        }
    }

    sendToSchool = () => {
        let val = document.getElementById("activeNow").checked;
        let hold = "";
        if(this.state.school !== 0)
        {
            if(val)
            {
                hold = "&priority=1";
            }
            fetch("https://api.involvedk12.org/api/sendQuiz.php?quiz=" + this.state.quizId + "&school=" + this.state.school + hold).then(alert("Sent Quiz"));
        }else{
            alert('Please Select A School');
        }
    }
    sendToGrade = () => {
        let val = document.getElementById("activeNow").checked;
        let hold = "";
        if(this.state.school !== 0)
        {
            if(this.state.grade !== 0)
            {
                if(val)
                {
                    hold = "&priority=1";
                }        
                fetch("https://api.involvedk12.org/api/sendQuiz.php?quiz=" + this.state.quizId + "&school=" + this.state.school + "&grade=" + this.state.grade + hold).then(alert("Sent Quiz"));    
            }else{
                alert("Please Select A Grade");
            }
        }else{
            alert('Please Select A School');
        }
    }
    sendToCourse = () => {
        let val = document.getElementById("activeNow").checked;
        let hold = "";
 
        if(this.state.school !== 0)
        {
            if(this.state.grade !== 0)
            {
                if(this.state.course !== 0)
                {
                    if(val)
                    {
                        hold = "&priority=1";
                    }
                    fetch("https://api.involvedk12.org/api/sendQuiz.php?quiz=" + this.state.quizId + "&course=" + this.state.course + hold).then(alert("Sent Quiz"));    
                }else{
                    alert("Please Select A Course");
                }
            }else{
                alert("Please Select A Grade");
            }
        }else{
            alert('Please Select A School');
        }
    }

    stopQuizes = () => {
        fetch("https://api.involvedk12.org/api/stopQuizes.php?priority=0").then(alert("Stoped Quizes"));
    }


    sendQuizNow = () => {
        let hold = "&priority=1";
        // alert(JSON.stringify(this.state.selectedStudents) + " | " + this.state.quizId);
        fetch("https://api.involvedk12.org/api/sendQuiz.php?quiz=" + this.state.quizId + "&users=" + this.state.selectedStudents + hold).then(alert("Sent Quiz"));
    }



    render() {

        const multiplesInDiv = (
            <div>
                <h1>Quiz Sender</h1>
                <div className='smallcard'>
                <QuizSelect quizId={this.state.quizId} updateQuiz={this.updateQuiz} quizes={this.state.quizes}></QuizSelect>
                <Quiz blurb={this.state.blurb} questions={this.state.questions}></Quiz>
                </div>
                <div className='smallcard'>
                <table><thead></thead><tbody>
                    <tr>
                        <td><button onClick={this.sendToSchool}>Send To School</button></td>
                        <td><button onClick={this.sendToGrade}>Send To Grade</button></td>
                        <td><button onClick={this.sendToCourse}>Send To Course</button></td>
                        <td></td>
                    </tr>
                    <tr><td>
                    <SchoolSelect setSchool={this.setSchool} schools={this.state.schools} school={this.state.school}>{this.props.children}</SchoolSelect>
                    </td><td>
                    <GradePicker setGrade={this.setGrade} grade={this.state.grade}>{this.props.children}</GradePicker>
                    </td><td>
                    <ClassDropdown course={this.state.course} setCourse={this.setCourse} courses={this.state.courses}>{this.props.children}</ClassDropdown>
                    </td></tr></tbody><tfoot></tfoot></table>
                    <StudentField checkAll={this.checkAll} uncheckAll={this.uncheckAll} updateStudents={this.updateStudents} selectedStudents={this.state.selectedStudents} students={this.state.students}>{this.props.children}</StudentField>
                </div>
                <table><thead></thead><tbody>
                    <tr>
                        <td>
                        <button onClick={this.stopQuizes}>Stop Quizes</button>
                        </td><td>
                        <button onClick={this.sendQuizNow}>Send Quiz Now</button>
                        </td><td>
                        <button onClick={this.sendQuiz}>Add Quiz To Queue</button>
                        </td>
                </tr></tbody><tfoot></tfoot></table>
            </div>
        );

        return multiplesInDiv;
    }
}

class QuizSelect extends React.Component {

    render() {
        const multiplesInDiv = (
            <select id="QuizSelect" onChange={this.props.updateQuiz} value={this.props.quizId}>
                <option id={0} value={0}>Please Select A Quiz</option>
                {
                    this.props.quizes.map(quiz =>(
                        <option value={quiz.id} key={Math.random(50000)}>{quiz.name}</option>
                    ))
                }
            </select>
            );
            return multiplesInDiv;
        }
    }


/**TODO:
 * Scheduled send functionality.
 * Check for Date Required quiz before going to the next un-answered quiz
 */


class SchoolSelect extends React.Component {
    render() {
        const multiplesInDiv = (
            <select id='schoolIdSelect' onChange={this.props.setSchool} value={this.props.school}>
                <option id={0} value={0}>Please Select A School</option>
                {this.props.schools.map(school => (
                    <option id={school.id} value={school.id} key={Math.random(50000)}>{school.name}</option>
                ))}
            </select>
        );
        return multiplesInDiv;
    }
}

export default QuizSender;